import React from 'react';
import { useSelector } from 'react-redux';

import TagElementPillsContainer from '../../../tags/TagElementPillsContainer';
import { selectTagsByIds } from '../../../tags/tagSelectors';
import { length } from '../../../../../common/utils/immutableHelper';
import { TaskTagData } from '../taskPillsTypes';

import './TaskTagPills.scss';

const TaskTagPills: React.FC<TaskTagData> = ({ tagIds }) => {
    const elementTags = useSelector(selectTagsByIds(tagIds));
    const tagsCount = length(elementTags);

    if (!tagsCount) return null;

    return (
        <div className="TaskTagPills">
            <TagElementPillsContainer tags={elementTags} size="xs" />
        </div>
    );
};

export default TaskTagPills;
